import type { WheelEvent } from 'react';

export type AssetLibraryViewMode = 'grid' | 'list';

/** Keep wheel scrolling inside library panels instead of the 3D viewport. */
export function stopAssetLibraryPanelWheelPropagation(
  event: WheelEvent<HTMLElement>,
) {
  event.stopPropagation();
}

export const ASSET_LIBRARY_PAGE_GRID_CLASS =
  'grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-4';

export const ASSET_LIBRARY_EMBEDDED_GRID_CLASS =
  'grid grid-cols-2 gap-0 sm:grid-cols-3 sm:gap-2 lg:grid-cols-4';

export const ASSET_LIBRARY_PAGE_LIST_CLASS = 'flex flex-col gap-2';

export const ASSET_LIBRARY_EMBEDDED_LIST_CLASS = 'flex flex-col gap-2';

export const ASSET_LIBRARY_LOAD_MORE_ROOT_MARGIN = '0px 0px 600px 0px';

export const ASSET_LIBRARY_PAGE_BODY_CLASS =
  'styled-scrollbar flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto';

export const ASSET_LIBRARY_EMBEDDED_BODY_CLASS = `${ASSET_LIBRARY_PAGE_BODY_CLASS} p-2 max-sm:overscroll-contain sm:p-6`;

export function getAssetLibraryGridClassName(
  embedded: boolean,
  viewMode: AssetLibraryViewMode = 'grid',
): string {
  if (viewMode === 'list') {
    return embedded
      ? ASSET_LIBRARY_EMBEDDED_LIST_CLASS
      : ASSET_LIBRARY_PAGE_LIST_CLASS;
  }

  return embedded
    ? ASSET_LIBRARY_EMBEDDED_GRID_CLASS
    : ASSET_LIBRARY_PAGE_GRID_CLASS;
}

export function getAssetLibraryBodyClassName(embedded: boolean): string {
  return embedded
    ? ASSET_LIBRARY_EMBEDDED_BODY_CLASS
    : ASSET_LIBRARY_PAGE_BODY_CLASS;
}

export function getAssetLibrarySkeletonCount(embedded: boolean): number {
  return embedded ? 10 : 6;
}
